import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Lottie from 'react-lottie';
import CheckedAnimation from '../../../animations/approved-checked-outline.json';
import {changeHandler, validateHandler, clearIsValid, doCallBack, setShowResponse} from './callBackBlockSlice';
import {Col, Row, Container} from 'reactstrap';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Loader from '../../Shared/Loader/Loader';
import {showAppLoader, hideAppLoader, showOverlay} from '../../Shared/Loader/LoaderSlice';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import {getRecaptchaToken} from './../../../utilities/recaptcha/recaptcha';
import ThemedLottie from '../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';

const CallBackForm = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [arrow, setArrow] = useState('down');

  const clickArrowButton = () => {
    setIsOpen(!isOpen);
    setArrow(arrow == 'down' ? 'up' : 'down');
  };

  const sendBtn = async () => {
    props.setShowResponse(false);
    props.validateHandler(props.form);
  };

  useEffect(() => {
    // Create an scoped async function in the hook
    async function doCallBack() {
      props.clearIsValid(props.form);
      props.showAppLoader({isLoading: true});
      props.doCallBack({form: props.form});
    }

    if (props.form.valid !== '') {
      if (props.form.valid) {
        doCallBack();
      }
    }
  }, [props.form.valid]);

  useEffect(() => {
    if (props.showResponse) {
      setTimeout(() => props.hideAppLoader({isLoading: false}), 500);
    }
  }, [props.showResponse]);

  return (
    <div className='callBackBlock'>
      <Container>
        <Row>
          <Col xs='12' sm='12' md='12'>
            <h1>{props.contentData.title.value}</h1>
          </Col>
        </Row>
        <Row>
          <Col xs='12' sm='12' md='12'>
            <p>{props.contentData.subTitle.value}</p>
          </Col>
        </Row>
        <Row>
          <Col xs='12' sm='12' md='12'>
            <button onClick={() => clickArrowButton()} className={`round-arrow-btn ${arrow}`}>
              <span className={`arrow ${arrow}`}></span>
            </button>
          </Col>
        </Row>
        {isOpen ? (
          props.isSuccess ? (
            <Row>
              <Col xs='12' sm='12' md='12'>
                <div className='success-msg'>
                  <div className='success-image-wrapper'>
                    {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={127} height={127} /> */}
                    <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={127} height={127} loop={false} />
                  </div>
                  <div className='title'>{props.contentData.titleSuccess.value}</div>
                  <div className='body'>{props.contentData.bodySuccess.value}</div>
                </div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs='12' sm='12' md='12'>
                <form>
                  <span className='required-fields-text'>שדות עם כוכבית הם חובה</span>
                  <TextInput
                    error={props.form.errors.id}
                    onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    value={props.form.id}
                    name='id'
                    type='text'
                    placeholder='ת.ז'
                    required='required'
                  />
                  <TextInput
                    error={props.form.errors.phone}
                    onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    value={props.form.phone}
                    name='phone'
                    type='text'
                    placeholder='מספר נייד'
                    required='required'
                  />
                  <ReactSelect
                    placeholderColor='#4a4a4a'
                    required={true}
                    error={props.form.errors.subject}
                    getOptionLabel={(option) => option.subjectName}
                    getOptionValue={(option) => option.id}
                    placeholder='בחר נושא פנייה'
                    isLoading={false}
                    value={props.contentData.subjects.value.filter((option) => option.id === props.form.subject)}
                    name='subject'
                    options={props.contentData.subjects.value}
                    onChange={(e) =>
                      props.changeHandler({
                        target: {name: 'subject', value: e.id},
                        form: props.form,
                      })
                    }
                  />
                  {props.showResponse && (
                    <div className='error-msg'>
                      <div dangerouslySetInnerHTML={{__html: props.contentData.bodyFailure.value}}></div>
                    </div>
                  )}
                  <BtnSubmit onclick={() => sendBtn()} text='שלח' formid='callbackForm'></BtnSubmit>
                </form>
              </Col>
            </Row>
          )
        ) : null}
      </Container>
      <Loader overlay={true} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isSuccess: state.callBackBlock.isSuccess,
    form: state.callBackBlock.form,
    showResponse: state.callBackBlock.showResponse,
    errorCode: state.callBackBlock.errorCode,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  clearIsValid,
  doCallBack,
  showAppLoader,
  hideAppLoader,
  showOverlay,
  setShowResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallBackForm);
